import { TaggedValueExtension, tagExtension } from '../core';

import { $Integer, Integer } from './integer';

const $ = 'Color';

export type Color = TaggedValueExtension<typeof $, Integer>;

export type ColorInput = number | bigint | HexString;

type HexString = `#${string}`;

const HEX_RADIX = 16;
const HEX_STRING_LENGTH = 6;
const HEX_SHORT_STRING_LENGTH = 3;
const HEX_LONG_STRING_LENGTH = 8;

export const $Color = {
  from(c: ColorInput): Color {
    switch (typeof c) {
      case 'string':
        if (typeof c === 'string') {
          let hexStr = c.slice(1).toLowerCase();

          if (hexStr.length === HEX_SHORT_STRING_LENGTH) {
            hexStr = hexStr
              .split('')
              .map((c) => c + c)
              .join('');
          }

          if (
            hexStr.length === HEX_LONG_STRING_LENGTH &&
            hexStr.endsWith('ff')
          ) {
            hexStr = hexStr.slice(0, HEX_STRING_LENGTH);
          }

          if (hexStr.length !== HEX_STRING_LENGTH) {
            throw new Error(`Invalid color string: ${c}`);
          }

          return parseInt(hexStr, HEX_RADIX) as Color;
        }
    }

    return tagExtension($, $Integer.from(c));
  },

  toString(color: Color, format: 'hex'): HexString {
    switch (format as string) {
      case 'hex': {
        return `#${color.toString(HEX_RADIX).padStart(HEX_STRING_LENGTH, '0')}`;
      }
    }
    throw new Error(`Unsupported color format: ${format}`);
  },
};
